var map = {
	"./Roboto-Black.woff2": "6ec1",
	"./Roboto-BlackItalic.woff2": "d06a",
	"./Roboto-Bold.woff2": "0da9",
	"./Roboto-BoldItalic.woff2": "ce83",
	"./Roboto-Light.woff2": "9f68",
	"./Roboto-LightItalic.woff2": "571a",
	"./Roboto-Medium.woff2": "282d",
	"./Roboto-MediumItalic.woff2": "fc6d",
	"./Roboto-Regular.woff2": "65b8",
	"./Roboto-RegularItalic.woff2": "dbf7",
	"./Roboto-Thin.woff2": "a345a",
	"./Roboto-ThinItalic.woff2": "ecf4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f5d6";